import React, { useEffect, useRef, useState } from 'react'
import Navbar from '../../componenets/Navbar'
import bgImage from '../../Images/Filtration.jpeg'
import Project_img1 from '../../Images/F1.jpeg'
import Project_img2 from '../../Images/F2.jpeg'
import Project_img3 from '../../Images/F3.jpeg'
import Project_img4 from '../../Images/Filtration.jpeg'
import { Link } from 'react-router-dom'
import Footer from '../../componenets/Footer'
import { FiArrowUpRight } from 'react-icons/fi'
import { BsArrowLeft, BsArrowRight } from 'react-icons/bs'
import WOW from "wowjs";
import "animate.css";



const Filtration = () => {

    const scrollRef = useRef(null);
  
    const [leftActive, setLeftActive] = useState(false);

    const scroll = (direction) => {
      const { current } = scrollRef;
    
      if (direction === "right") {
        setLeftActive(true); // left becomes active
      }
    
      if (direction === "left") {
        setLeftActive(false); // optional: left goes back to default
      }
    
      if (current) {
        const scrollAmount = 300;
        current.scrollBy({
          left: direction === "left" ? -scrollAmount : scrollAmount,
          behavior: "smooth",
        });
      }
    };

  const images = [
    Project_img1, Project_img2, Project_img3, Project_img4
  ];

  useEffect(() => {
    new WOW.WOW({
      live: false
    }).init();
  }, []);


  return (
    <div>
        <Navbar />

    <section
      className="about_who-we-are"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="about_who-we-are-content">
        <p className="about_tag">Services</p>
        <h1>Filtration Services</h1>
      </div>
    </section>

    <section className="border_bottom_div wow animate__animated animate__fadeInUp">
        <h2>High-capacity filtration for cleaner wells and protected assets.</h2>
    </section>

    <section className="services_detail_text wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
        <p>Our filtration solutions ensure clean and contaminant-free fluids across drilling, completion, and production phases.</p>
        <p>We deploy high-capacity filtration units that efficiently remove solids, suspended particles, and hydrocarbons to maintain fluid quality and protect equipment integrity</p>
        <p>Whether for brine filtration, completion fluids, or produced water treatment, we deliver consistent results backed by strong technical expertise and safety standards.</p>
        <Link to="/contact">
          <div className="contactBtn">
            <button className="contact-btn">
                Become a Client
            </button>
            <button className="contact-btn">
                <FiArrowUpRight  size={24}/>
            </button>
          </div>
        </Link>
    </section> 

    <div className="project_work wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
    <div className="project_ontrol_btn">
      <button
        className={leftActive ? "active" : ""}
        onClick={() => scroll("left")}
      >
        <BsArrowLeft />
      </button>

      <button className="active" onClick={() => scroll("right")}>
        <BsArrowRight />
      </button>
    </div>
        <div className="project_img_carrier">
           <div className="project_container" ref={scrollRef}>
            {images.map((img, index) => (
                <div className="project_work_items" key={index}>
                <img src={img} alt={`project-${index}`} />
                </div>
            ))}
           </div>
        </div>
    </div> 



    {/* <div className="carousel-wrapper">
      <div className="carousel-container" ref={scrollRef}>
        {images.map((src, i) => (
          <div className="carousel-item" key={i}>
            <img src={src} alt={`slide-${i}`} className="carousel-image" />
          </div>
        ))}
      </div>

      <div className="carousel-controls">
        <button className="arrow left" onClick={() => scroll("left")}>
          &#8592;
        </button>
        <button className="arrow right" onClick={() => scroll("right")}>
          &#8594;
        </button>
      </div>
    </div> */}




    <Footer />

    </div>
  )
}

export default Filtration